import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { Colors } from '@common/tokens';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { PerformWorksShiftAction } from '@scheduling/graphql';
import { ShiftRejectModal } from '@scheduling/components';

export function PerformWorksShiftActionButton({ worksShiftId, type }) {
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectShiftId, setRejectShiftId] = useState('');

  const [performConfirmAction] = useMutation(PerformWorksShiftAction, {
    onCompleted: (response) => {
      const worksShift = response.performWorksShiftAction?.worksShift;

      const integrationEnabled =
        worksShift?.organization?.vendorShiftBookingEnabled;
      let message =
        'Shift confirmed. Please be sure this shift is booked to your schedule.';
      if (integrationEnabled) {
        message =
          'Shift approved. This shift will be booked to your schedule shortly.';
      }
      createMessage('success', message);
    },
    onError: () => {
      createMessage(
        'error',
        'Failed to change works shift state. Please try again.'
      );
    },
    refetchQueries: [
      'ShiftGapDetails',
      'PaginatedShiftGapOpenings',
      'ShiftsByDay',
    ],
  });

  const confirmWorksShiftState = () => {
    performConfirmAction({
      variables: {
        worksShiftId: worksShiftId,
        input: {
          action: 'confirm',
        },
      },
    });
  };

  return (
    <>
      {type === 'confirm' ? (
        <Button
          size="middle"
          type="secondary"
          onClick={(e) => {
            e.stopPropagation();
            confirmWorksShiftState();
          }}
        >
          Approve
        </Button>
      ) : (
        <div onClick={(e) => e.stopPropagation()}>
          <Button
            size="middle"
            type="secondary"
            style={{ color: Colors.coral, borderColor: Colors.coral }}
            onClick={() => {
              setRejectModalOpen(true);
              setRejectShiftId(worksShiftId);
            }}
          >
            Reject
          </Button>
          <ShiftRejectModal
            open={rejectModalOpen}
            worksShiftId={rejectShiftId}
            setOpen={(value) => setRejectModalOpen(value)}
          />
        </div>
      )}
    </>
  );
}

PerformWorksShiftActionButton.propTypes = {
  worksShiftId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
